'use strict';

class BrregLookup {
  constructor($scope, $timeout) {
    this.$scope = $scope;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.q = null;
    this.brreg = [];
    this.lastSelection = null;
  }

  $onChanges() {
    let promise;

    this.$timeout.cancel(promise);

    promise = this.$timeout(() => {
      this.search(this.q);
    }, 600);
  }

  search() {
    if (this.q && this.q !== null && this.q !== '' && this.q !== this.lastSelection) {
      $.getJSON(`//data.brreg.no/enhetsregisteret/api/enheter?navn=${this.q}&size=50`)
        .then((resp) => {
          this.$scope.$apply(() => {
            let elements = resp.page.totalElements;
            if (elements > 0) {
              this.brreg = resp._embedded.enheter.map((entry) => {
                let newEntry = {
                  name: entry.navn,
                  orgNo: entry.organisasjonsnummer,
                  orgForm: entry.organisasjonsform.kode.toLowerCase() === 'nuf' ? 'ue' : entry.organisasjonsform.kode.toLowerCase(),
                  address: {},
                  mvaRegistered: entry.registrertIMvaregisteret,
                  foretaksRegistered: entry.registrertIForetaksregisteret
                };

                if (entry.postadresse) {
                  newEntry.address = {
                    address1: entry.postadresse.adresse.length > 0 ? entry.postadresse.adresse[0] : null,
                    address2: entry.postadresse.adresse.length > 1 ? entry.postadresse.adresse[1] : null,
                    city: entry.postadresse.poststed,
                    zip: entry.postadresse.postnummer,
                    country: entry.postadresse.land.toUpperCase()
                  };
                } else if (entry.forretningsadresse) {
                  newEntry.address = {
                    address1: entry.forretningsadresse.adresse.length > 0 ? entry.forretningsadresse.adresse[0] : null,
                    address2: entry.forretningsadresse.adresse.length > 1 ? entry.forretningsadresse.adresse[1] : null,
                    city: entry.forretningsadresse.poststed,
                    zip: entry.forretningsadresse.postnummer,
                    country: entry.forretningsadresse.land.toUpperCase()
                  };
                }
                return newEntry;
              });
            }
          });
        });
    } else {
      this.brreg = [];
    }
  }

  select(entry) {
    this.$scope.$broadcast('selectedBrreg', entry);
    this.$scope.$emit('selectedBrreg', entry);

    this.lastSelection = entry.name;
    this.brreg = [];
  }
}

BrregLookup.$inject = ['$scope', '$timeout'];

const brregLookup = {
  bindings: {
    q: '<'
  },
  controller: BrregLookup,
  template: `
    <p ng-show="$ctrl.brreg.length">{{ $ctrl.brreg.length }} treff i Br&oslash;nn&oslash;ysundregistrene for <b>{{ $ctrl.q }}</b></p>

    <div ng-show="$ctrl.brreg.length" class="scroll-content do-brreg-search">
      <div class="inner">
        <a href ng-click="$ctrl.select(hint)" ng-repeat="hint in $ctrl.brreg">{{ hint.name }}</a>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('brregLookup', brregLookup);
